/*
 * Embroidery add-on sync (cart drawer + cart page)
 *
 * The embroidery fee (assets/product-embroidery.js, formerly the Easify app) is a separate cart
 * line linked to the garment with line-item properties:
 *   garment line:  _tpo_is_main_product = "1", _tpo_add_on_keys = '["<uuid>", ...]'
 *   fee line:      _tpo_add_on_key = "<uuid>"
 * Each fee line's quantity must equal the total quantity of the garment line(s) that reference
 * it (0 when the garment was removed). Fixes are sent through the theme's own cart update event,
 * one line at a time, so the drawer re-renders normally. If the Easify app is ever loaded again
 * (window.TPOConfigs), this script stands down and lets Easify do it.
 */
(function () {
  'use strict';

  var MAX_FIXES_PER_PAGE = 20;
  var fixes = 0;
  var busy = false;

  function easifyIsActive() {
    return typeof window.TPOConfigs !== 'undefined';
  }

  function hasAddonRows() {
    return document.querySelector('[data-cart-item][data-tpo-addon-key]') !== null;
  }

  function wantedQuantities(cart) {
    var wanted = {};
    cart.items.forEach(function (item) {
      var props = item.properties || {};
      if (!props._tpo_is_main_product || !props._tpo_add_on_keys) return;
      var keys = [];
      try {
        keys = JSON.parse(props._tpo_add_on_keys) || [];
      } catch (e) {
        keys = [];
      }
      keys.forEach(function (key) {
        wanted[key] = (wanted[key] || 0) + item.quantity;
      });
    });
    return wanted;
  }

  function firstMismatch(cart) {
    var wanted = wantedQuantities(cart);
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var key = (item.properties || {})._tpo_add_on_key;
      if (!key) continue;
      var target = wanted[key] || 0;
      if (item.quantity !== target) return {lineKey: item.key, quantity: target};
    }
    return null;
  }

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  function reconcile() {
    if (busy || easifyIsActive() || !hasAddonRows() || fixes >= MAX_FIXES_PER_PAGE) return;
    busy = true;

    fetch(cartUrl('cart.js'), {headers: {Accept: 'application/json'}, credentials: 'same-origin'})
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var fix = firstMismatch(cart);
        if (!fix) {
          busy = false;
          return;
        }
        fixes++;

        var row = document.querySelector('[data-cart-item][data-item="' + fix.lineKey + '"]');
        if (row) {
          // Let the theme change the line and re-render the cart; 'theme:cart:added' fires
          // after the re-render and triggers the next check.
          busy = false;
          row.dispatchEvent(
            new CustomEvent('theme:cart:update', {
              bubbles: true,
              detail: {id: fix.lineKey, quantity: fix.quantity},
            })
          );
          return;
        }

        // Row not rendered (cart not on screen): fix directly by line key.
        return fetch(cartUrl('cart/change.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({id: fix.lineKey, quantity: fix.quantity}),
        }).then(function () {
          busy = false;
          reconcile();
        });
      })
      .catch(function () {
        busy = false;
      });
  }

  ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:open'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      window.setTimeout(reconcile, 50);
    });
  });

  window.addEventListener('load', reconcile);
})();
